module.exports = __webpack_public_path__ + "media/images/lp_consultation/merit02-903bbff437e8a50790a2ea6efe8695ca.jpg";